import { apiCall } from "../../../utils/api.utils";
import { API_URLS } from "../../../constants/apiUrls";

export const disbursementService = {
  getAllDisbursements, getDisbursementById, createDisbursement, getAllRaffles, getAllWinners, disbursementAction
};

function getAllDisbursements(params) {
  if(params && params.searchWord){
    params.searchKey = params.searchWord
  }
  return apiCall("GET", API_URLS.DISBURSEMENT.GET_ALL_DISBURSEMENTS, null, null, params);
}
function getAllWinners(params) {
  return apiCall("GET", API_URLS.DISBURSEMENT.GET_WINNERS_LIST, null, null, params);
}

function getAllRaffles() {
  return apiCall("GET", API_URLS.DISBURSEMENT.RAFFLES_DROPDOWN, null, null, null);
}

function getDisbursementById(id) {
  const method = "GET";

  const apiUrl = `${API_URLS.DISBURSEMENT.GET_ALL_DISBURSEMENTS}/${id}`;

  return apiCall(method, apiUrl, null, null);
}

function  createDisbursement(request) {
  
  const method =  request.id ? "PUT" : "POST";
  const url = method === "PUT" ? `${API_URLS.DISBURSEMENT.GET_ALL_DISBURSEMENTS}/${request.id}` : API_URLS.DISBURSEMENT.GET_ALL_DISBURSEMENTS;
  
  return apiCall(method, url, null, request);
}

function  disbursementAction(request) {
  
  const method =  request.id ? "PUT" : "POST";
  
  return apiCall(method, API_URLS.DISBURSEMENT.REVIEW_DISBURSEMENT, null, request);
}

